import { Account } from '@/Domain/Account'

export class AccountDto {
  private _username: string
  private _accountId: string

  public static fromAccount (account: Account): AccountDto {
    return new this(account.userName(), account.accountId())
  }

  constructor (username: string, accountId: string) {
    this._username = username
    this._accountId = accountId
  }

  get username (): string {
    return this._username
  }

  get accountId (): string {
    return this._accountId
  }

  toJSON (): { username: string; accountId: string } {
    return {
      username: this.username,
      accountId: this.accountId
    }
  }
}
